export const ButtonTypes = {
    primary: 'PRIMARY',
    secondary: 'SECONDARY',
    secondarySmall: 'SECONDARY_SMALL',
    ghost: 'GHOST',
    ghostSmall: 'GHOST_SMALL',
    ghostBorder: 'GHOST_BORDER',
    icon: 'ICON',
    iconSmall: 'ICON_SMALL',
    custom: 'CUSTOM',
}